export const environment = {
    production: false,
    label: 'dev',
    API_GATEWAY_URL: 'https://dev-api.bciti.info',
    API_VOICE_URL: 'https://parkingadmin-uat.bciti.info/api/voice/saveNotification.php',
    VOICE_URL: 'https://parkingadmin-uat.bciti.info/api/voice/plivotest.php',
    API_PERMIT_URL: 'https://parkingadmin-uat.bciti.info/api/sdp/user/',
    PERMIT_URL: 'https://bcitiv3.sdp-uat.com/api/bcitipermit',
    AUTH_SERVICE_URL: 'https://auth-service-dev-gpgzbrhrfcbcb2em.canadacentral-01.azurewebsites.net',
    OIDC_PLATFORM: 'admin',
    OIDC_ORG_ID: '362927438801403907',
    ZITADEL_ISSUER: 'https://auth-dev.bciti.com',
};
